import { Price } from '@/types/products';

export function checkIfPriceIsAvailable(price: Price) {
  return price && Number(price.netPrice) >= 0 && !price.askForPrice;
}

const isNegativeNumber = (value: number) => Math.sign(value) === -1;

export const formatPrice = (value: number | '-1') => {
  if (value === '-1') return value;

  if (isNegativeNumber(value)) return '0 kr';

  if (isNaN(value)) return '';

  const number = Number(value);
  let fractionDigits = 2;
  if (number % 1 === 0) fractionDigits = 0;

  return new Intl.NumberFormat('sv', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: fractionDigits,
  }).format(number);
};

export const formatPercentage = (value?: number) => {
  if (!value && value !== 0) return '';
  if (isNaN(value)) return '';

  const number = Number(value);
  let fractionDigits = 2;
  if (number % 1 === 0) fractionDigits = 0;
  const fraction = value / 100;

  return new Intl.NumberFormat('sv', {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
  }).format(fraction);
};
